import {
  DefaultValuesDetailsForm,
  IndividualFormProps,
} from "../../Layouts/WebCheckInForms/WebCheckInForms.props";
import {
  ReadOnlyIfInitialValuesNotProvided,
  SoleTraderFormFields,
} from "../../Layouts/WebCheckInForms/FormOptions";

import { AppInputSwitchProps } from "../../Layouts/AppInputSwitcher/AppInputSwitcher.props";
import { AppInputSwitcher } from "../../Layouts/AppInputSwitcher/AppInputSwitcher";
import { FormFieldErrorMessage } from "../FormFieldErrorMessage/FormFieldErrorMessage";
import React from "react";
import { RegisterOptions } from "react-hook-form/dist/types/validator";
import { SelfDriverFormFields } from "../../Layouts/WebCheckInForms/FormKeys";
import { emailRegex } from "../../../@types/REGEX";
import { useTranslation } from "react-i18next";
import { useWebCheckInForm } from "../../../hooks/DriverWebCheckInForm";
import i18n from "../../../config/i18n";
import { t } from "i18next";

export function SoleTraderForm({
  values = { ...DefaultValuesDetailsForm },
  initialValues = { ...DefaultValuesDetailsForm },
  //onChange = () => {},
  children = <></>,
  onSubmit = () => {},
}: IndividualFormProps) {
  const [
    {
      register,
      formState: { errors },
      getValues,
      setValue,
      handleSubmit,
    },
    soleTraderFormFields,
  ] = useWebCheckInForm(SoleTraderFormFields, {
    ...values,
  });

  const { t: translate } = useTranslation();
  const handleCountryChange = (newCountryValue) => {
    setValue("country", newCountryValue || "");
    setValue("city", "");
    setValue("state", "");
  };

  const genderMap = {
    MALE: {
      it: "MASCHIO",
      en: "MALE",
      fr: "HOMME",
      es: "MASCULINO",
    },
    FEMALE: {
      it: "FEMMINA",
      en: "FEMALE",
      fr: "FEMME",
      es: "FEMININA",
    },
  };

  return (
    <form className={"flex flex-col gap-4"} onSubmit={handleSubmit(onSubmit)}>
      {Object.values(soleTraderFormFields).map((el: AppInputSwitchProps) => {
        const isGenderField = el.key === "sex";
        const readOnly =
          el.readOnly ||
          isGenderField ||
          (ReadOnlyIfInitialValuesNotProvided.includes(el.key) &&
            !!getValues(el.key));
        const options: RegisterOptions = {
          required: {
            value: !!el.required,
            message: translate("This is a required field"),
          },
        };
        if (el.type === "email") {
          options.pattern = {
            value: emailRegex,
            message: translate("Please provide a valid email"),
          };
        }
        if (el.key === "vatNumber") {
          options.validate = (value) => {
            const birthNation = getValues("birthNation");
            if (birthNation === "ITALIA") {
              if (!/^\d+$/.test(value))
                return translate("VAT number must contain only digits");
              if (value.length !== 11)
                return translate("VAT number must be 11 digits long");
            }
            return true;
          };
        }

        const translatedGenderValue =
          isGenderField && initialValues.sex
            ? genderMap[initialValues.sex]?.[i18n.language] || initialValues.sex
            : getValues(el.key) || "";

        const fieldOptions = isGenderField
          ? [translate("MALE"), translate("FEMALE")]
          : el.options || [];

        return (
          <div key={el.key}>
            <AppInputSwitcher
              {...el}
              {...register(el.key, {
                ...options,
              })}
              onChange={() => {}}
              className="h-[80px]"
              readOnly={readOnly}
              label={translate(el.label || "")}
              required={false}
              placeholder={translate(el.placeholder || "")}
              value={translatedGenderValue}
              options={fieldOptions}
              onchange={async (e) => {
                if (el.key == "country") {
                  handleCountryChange(e);
                }
                setValue(el.key, e, {
                  // shouldValidate: true,
                });
              }}
            />
            <FormFieldErrorMessage>
              {errors[el.key]?.message}
            </FormFieldErrorMessage>
          </div>
        );
      })}
      <div className={"flex flex-col gap-4"}>
        {getValues("isSignatoryTheMainDriver") === "YES" &&
          Object.values(SelfDriverFormFields).map(
            (el: AppInputSwitchProps, index: number) => {
              const readOnly =
                el.readOnly ||
                (ReadOnlyIfInitialValuesNotProvided.includes(el.key) &&
                  !!initialValues[el.key]);
              return (
                <div key={index}>
                  <AppInputSwitcher
                    {...el}
                    {...register(el.key, {
                      required: {
                        value: !!el.required,
                        message: translate("This is a required field"),
                      },
                    })}
                    required={false}
                    onChange={() => {}}
                    label={translate(el.label || "")}
                    readOnly={readOnly}
                    value={getValues(el.key) || ""}
                    key={el.key + index}
                    className={"h-[80px]"}
                    onchange={(e: string) => {
                      setValue(el.key, e, {
                        shouldValidate: true,
                      });
                    }}
                  />
                  <FormFieldErrorMessage>
                    {errors[el.key]?.message}
                  </FormFieldErrorMessage>
                </div>
              );
            }
          )}
      </div>
      {children}
    </form>
  );
}
